import { render, staticRenderFns } from "./judge-registration-certificate.vue?vue&type=template&id=2cb8a6b2&scoped=true&"
import script from "./judge-registration-certificate.vue?vue&type=script&lang=js&"
export * from "./judge-registration-certificate.vue?vue&type=script&lang=js&"
import style0 from "./judge-registration-certificate.vue?vue&type=style&index=0&id=2cb8a6b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8a6b2",
  null
  
)

export default component.exports